import { render, staticRenderFns } from "./AllCertificationSubmissions.vue?vue&type=template&id=aa7e2850&scoped=true&"
import script from "./AllCertificationSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllCertificationSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllCertificationSubmissions.vue?vue&type=style&index=0&id=aa7e2850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7e2850",
  null
  
)

export default component.exports